/**
 * Custom: gaveindpakning i kurven (se snippets/gift-wrap.liquid).
 * Bruger event delegation, så det virker efter at temaet har genindlæst kurven.
 */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';

  const refreshCart = () => {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  };

  const setLoading = (box, loading) => {
    box.classList.toggle('is-loading', loading);
  };

  const showError = (box, message) => {
    const el = box.querySelector('[data-gift-wrap-error]');
    if (el) el.textContent = message || '';
  };

  document.addEventListener('change', (e) => {
    const toggle = e.target.closest('[data-gift-wrap-toggle]');
    if (!toggle) return;

    const box = toggle.closest('[data-gift-wrap]');
    const panel = box.querySelector('.gift-wrap__panel');
    panel.hidden = !toggle.checked;
    toggle.setAttribute('aria-expanded', String(toggle.checked));
    showError(box, '');
  });

  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-gift-wrap-add]');
    const removeBtn = e.target.closest('[data-gift-wrap-remove]');
    if (!addBtn && !removeBtn) return;

    const box = (addBtn || removeBtn).closest('[data-gift-wrap]');
    showError(box, '');

    if (addBtn) {
      const paper = box.querySelector('input[name="gift-wrap-paper"]:checked');
      const ribbon = box.querySelector('input[name="gift-wrap-ribbon"]:checked');
      const ribbonRequired = box.dataset.ribbonRequired === 'true';

      if (!paper || (ribbonRequired && !ribbon)) {
        showError(box, box.dataset.errorChoose);
        return;
      }

      const items = [{ id: Number(paper.value), quantity: 1 }];
      if (ribbon) items.push({ id: Number(ribbon.value), quantity: 1 });

      setLoading(box, true);
      try {
        const res = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error((await res.json()).description);
        refreshCart();
      } catch (err) {
        setLoading(box, false);
        showError(box, err.message || box.dataset.errorGeneric);
      }
      return;
    }

    // Fjern gaveindpakning
    const updates = {};
    removeBtn.dataset.giftWrapRemove
      .split(',')
      .filter(Boolean)
      .forEach((id) => {
        updates[id] = 0;
      });

    setLoading(box, true);
    try {
      const res = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!res.ok) throw new Error();
      refreshCart();
    } catch (err) {
      setLoading(box, false);
      showError(box, box.dataset.errorGeneric);
    }
  });
})();
